
import { LOCATION_CHANGE } from 'react-router-redux'

export type PUSH_PREV_PATH_TYPE = 'PUSH_PREV_PATH'
export const PUSH_PREV_PATH: PUSH_PREV_PATH_TYPE = 'PUSH_PREV_PATH'
export type CLEAR_PREV_PATH_TYPE = 'CLEAR_PREV_PATH'
export const CLEAR_PREV_PATH: CLEAR_PREV_PATH_TYPE = 'CLEAR_PREV_PATH'

export const clearPrevPath = () => {
    return ({
        type: CLEAR_PREV_PATH,
    })
}

export const pushPrevPath = (pathName: string) => {
    return ({
        type: PUSH_PREV_PATH,
        payload: {
            pathName: pathName,
        },
    })
}

export default () => (next: any) => (action: any) => {
    if (action.type === LOCATION_CHANGE) {
        if (action.payload.pathname.indexOf('/clan-profile') === -1) {
            next(action)
            return next(clearPrevPath())
        } else {
            next(action)
            return next(pushPrevPath(action.payload.pathname))
        }
    } else {
        return next(action)
    }
}